/**
 * Menu Site — HTML/CSS compartilhado entre visualização e exportação.
 * O palco usa as mesmas classes em RenderSiteMenu.
 */

const SVG_LOGIN = {
  LogIn: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>',
  User: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
  KeyRound: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"/><circle cx="16.5" cy="7.5" r=".5" fill="currentColor"/></svg>',
  LogOut: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>',
};

const SVG_CHEVRON = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
const SVG_MENU = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/></svg>';
const SVG_CLOSE = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

export const SITE_MENU_CSS = `
.madri-site-menu{box-sizing:border-box;background:var(--sm-bg,#fff);color:var(--sm-link,#0f172a);font-family:inherit}
.madri-site-menu--shadow{box-shadow:0 1px 0 rgba(15,23,42,.08),0 8px 24px rgba(15,23,42,.06)}
.madri-site-menu--transparent{background:transparent;box-shadow:none}
.madri-site-menu--full{width:100vw;max-width:100vw;margin-left:calc(50% - 50vw);margin-right:calc(50% - 50vw)}
.madri-site-menu--fixed{position:fixed;top:0;left:0;right:0;width:100%;max-width:none;margin:0;z-index:80}
.madri-site-menu--boxed.madri-site-menu--fixed{left:50%;right:auto;width:min(1200px,100%);transform:translateX(-50%)}
.madri-site-menu-slot:has(.madri-site-menu--fixed){min-height:var(--sm-slot,72px)}
.madri-site-menu__bar{display:flex;align-items:center;gap:16px;max-width:1200px;margin:0 auto;padding:12px 24px;min-height:var(--sm-slot,72px);box-sizing:border-box}
.madri-site-menu--boxed .madri-site-menu__bar{max-width:none}
.madri-site-menu__logo{display:flex;align-items:center;flex:0 0 auto;text-decoration:none;color:inherit;font-weight:700;font-size:18px;line-height:1}
.madri-moodle-layout .madri-site-menu__logo img,.madri-site-menu__logo img{height:var(--sm-logo-h,40px) !important;width:auto !important;max-width:180px;object-fit:contain;display:block;border-radius:0 !important}
.madri-site-menu__nav{flex:1 1 auto;display:flex;justify-content:center}
.madri-site-menu__list,.madri-site-menu__sub,.madri-moodle-layout .madri-site-menu__list,.madri-moodle-layout .madri-site-menu__sub{list-style:none !important;margin:0 !important;padding:0 !important}
.madri-site-menu li,.madri-moodle-layout .madri-site-menu li{list-style:none !important}
.madri-site-menu li::marker,.madri-moodle-layout .madri-site-menu li::marker{content:none !important}
.madri-site-menu__list{display:flex;align-items:center;gap:4px;flex-wrap:wrap;justify-content:center}
.madri-site-menu__item{position:relative}
.madri-site-menu__link,.madri-site-menu__sub a{display:inline-flex;align-items:center;gap:6px;color:var(--sm-link,#0f172a);text-decoration:none;font-size:var(--sm-size,15px);font-weight:600;line-height:1.2;padding:8px 12px;border-radius:8px}
.madri-site-menu__link:hover,.madri-site-menu__sub a:hover{color:var(--sm-hover,#2563eb)}
.madri-site-menu--underline .madri-site-menu__link{border-radius:0;border-bottom:2px solid transparent}
.madri-site-menu--underline .madri-site-menu__link:hover{border-bottom-color:var(--sm-hover,#2563eb)}
.madri-site-menu--pills .madri-site-menu__link{background:rgba(15,23,42,.06)}
.madri-site-menu--pills .madri-site-menu__link:hover{background:var(--sm-hover,#2563eb);color:#fff}
.madri-site-menu__sub{display:none;position:absolute;top:100%;left:0;min-width:200px;background:#fff;color:#0f172a;border-radius:10px;box-shadow:0 12px 32px rgba(15,23,42,.16);padding:6px;z-index:5}
.madri-site-menu__sub a{display:flex;width:100%;color:#0f172a;font-weight:500}
.madri-site-menu__item:hover>.madri-site-menu__sub,.madri-site-menu__item.is-open>.madri-site-menu__sub{display:block}
.madri-site-menu__caret{border:0;background:transparent;color:inherit;padding:4px;cursor:pointer;display:none}
.madri-site-menu__login{margin-left:auto;display:inline-flex;align-items:center;gap:8px;flex:0 0 auto;text-decoration:none;background:var(--sm-login-bg,#2563eb);color:var(--sm-login,#fff);font-weight:700;font-size:14px;padding:8px 14px;border-radius:999px;line-height:1}
.madri-site-menu__login svg{display:block}
.madri-site-menu__logout{display:none !important}
.madri-site-menu.is-logged-in .madri-site-menu__login[data-sm-auth="in"]{display:none !important}
.madri-site-menu.is-logged-in .madri-site-menu__logout{display:inline-flex !important}
.madri-site-menu__toggle{display:none;margin-left:8px;border:0;background:transparent;color:inherit;padding:6px;cursor:pointer}
@media (max-width:860px){
  .madri-site-menu__toggle{display:inline-flex}
  .madri-site-menu__nav{display:none;position:absolute;left:0;right:0;top:100%;background:var(--sm-bg,#fff);padding:8px 16px 16px;box-shadow:0 16px 32px rgba(15,23,42,.12)}
  .madri-site-menu.is-open .madri-site-menu__nav{display:block}
  .madri-site-menu__list{flex-direction:column;align-items:stretch}
  .madri-site-menu__sub{position:static;display:none;box-shadow:none;padding:0 0 0 12px;background:transparent}
  .madri-site-menu__item.is-open>.madri-site-menu__sub{display:block}
  .madri-site-menu__caret{display:inline-flex}
  .madri-site-menu__item:hover>.madri-site-menu__sub{display:none}
  .madri-site-menu__item.is-open:hover>.madri-site-menu__sub{display:block}
}
`.replace(/\s+/g, ' ').trim();

function escText(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function escAttr(value) {
  return escText(value).replace(/"/g, '&quot;');
}

function safeId(widgetId) {
  const raw = String(widgetId || 'menu').replace(/[^a-zA-Z0-9_-]/g, '');
  return raw || 'menu';
}

export function createDefaultSiteMenuContent(labels = {}) {
  return {
    widthMode: 'full',
    behavior: 'static',
    menuStyle: 'classic',
    barBg: '#ffffff',
    linkColor: '#0f172a',
    linkHoverColor: '#2563eb',
    logoUrl: '',
    logoAlt: labels.logoAlt || 'Logo',
    logoText: labels.logoText || 'Minha escola',
    logoHref: '/',
    logoHeight: 40,
    fontSize: 15,
    loginEnabled: true,
    loginLabel: labels.loginLabel || 'Entrar',
    loginHref: '/login/index.php',
    loginIcon: 'LogIn',
    loginBg: '#2563eb',
    loginColor: '#ffffff',
    logoutEnabled: true,
    logoutLabel: labels.logoutLabel || 'Sair',
    logoutHref: '/login/logout.php',
    logoutIcon: 'LogOut',
    items: [
      { label: labels.home || 'Home', href: '#', openNewTab: false, children: [] },
      { label: labels.about || 'Sobre', href: '#sobre', openNewTab: false, children: [] },
      {
        label: labels.courses || 'Cursos',
        href: '#cursos',
        openNewTab: false,
        children: [{ label: labels.courseItem || 'Curso 1', href: '#curso-1', openNewTab: false }],
      },
      { label: labels.contact || 'Contato', href: '#contato', openNewTab: false, children: [] },
    ],
    marginObj: { top: 0, right: 0, bottom: 0, left: 0 },
  };
}

function linkAttrs(href, openNewTab) {
  const url = String(href || '#').trim() || '#';
  const target = openNewTab && !url.startsWith('#') ? ' target="_blank" rel="noopener noreferrer"' : '';
  return ` href="${escAttr(url)}"${target}`;
}

function renderItems(items) {
  return (Array.isArray(items) ? items : []).map((item) => {
    const label = String(item?.label || '').trim();
    if (!label) return '';
    const children = (Array.isArray(item.children) ? item.children : []).filter((child) => String(child?.label || '').trim());
    const sub = children.length
      ? `<button type="button" class="madri-site-menu__caret" aria-label="${escAttr(label)}">${SVG_CHEVRON}</button><ul class="madri-site-menu__sub">${children.map((child) => `<li><a${linkAttrs(child.href, child.openNewTab)}>${escText(child.label)}</a></li>`).join('')}</ul>`
      : '';
    return `<li class="madri-site-menu__item${children.length ? ' has-sub' : ''}"><a class="madri-site-menu__link"${linkAttrs(item.href, item.openNewTab)}>${escText(label)}</a>${sub}</li>`;
  }).join('');
}

export function buildSiteMenuInnerHtml(content, widgetId) {
  const c = content || {};
  const id = `madri-site-menu-${safeId(widgetId)}`;
  const widthMode = c.widthMode === 'boxed' ? 'boxed' : 'full';
  const fixed = c.behavior === 'fixed';
  const style = ['classic', 'underline', 'pills', 'transparent'].includes(c.menuStyle) ? c.menuStyle : 'classic';
  const logoUrl = String(c.logoUrl || '').trim();
  const logoAlt = escAttr(c.logoAlt || c.logoText || 'Logo');
  const logoInner = logoUrl
    ? `<img src="${escAttr(logoUrl)}" alt="${logoAlt}">`
    : escText(c.logoText || 'Logo');
  const logoHref = String(c.logoHref || '').trim();
  const logo = logoHref
    ? `<a class="madri-site-menu__logo"${linkAttrs(logoHref, false)}>${logoInner}</a>`
    : `<span class="madri-site-menu__logo">${logoInner}</span>`;
  const loginOn = c.loginEnabled !== false && String(c.loginLabel || c.loginHref || '').trim();
  const loginIcon = SVG_LOGIN[c.loginIcon] || SVG_LOGIN.LogIn;
  const login = loginOn
    ? `<a class="madri-site-menu__login" data-sm-auth="in"${linkAttrs(c.loginHref || '/login/index.php', false)}>${loginIcon}<span>${escText(c.loginLabel || 'Entrar')}</span></a>`
    : '';
  const logoutOn = c.logoutEnabled !== false;
  const logoutIcon = SVG_LOGIN[c.logoutIcon] || SVG_LOGIN.LogOut;
  const logout = logoutOn
    ? `<a class="madri-site-menu__login madri-site-menu__logout" data-sm-auth="out"${linkAttrs(c.logoutHref || '/login/logout.php', false)}>${logoutIcon}<span>${escText(c.logoutLabel || 'Sair')}</span></a>`
    : '';
  const vars = [
    `--sm-bg:${c.barBg || '#ffffff'}`,
    `--sm-link:${c.linkColor || '#0f172a'}`,
    `--sm-hover:${c.linkHoverColor || '#2563eb'}`,
    `--sm-login-bg:${c.loginBg || '#2563eb'}`,
    `--sm-login:${c.loginColor || '#ffffff'}`,
    `--sm-size:${Number(c.fontSize) || 15}px`,
    `--sm-logo-h:${Number(c.logoHeight) || 40}px`,
    `--sm-slot:${Math.max(56, (Number(c.logoHeight) || 40) + 32)}px`,
  ].join(';');
  const classes = [
    'madri-site-menu',
    `madri-site-menu--${widthMode}`,
    `madri-site-menu--${style}`,
    style !== 'transparent' ? 'madri-site-menu--shadow' : '',
    fixed ? 'madri-site-menu--fixed' : '',
  ].filter(Boolean).join(' ');
  const script = `<script>(function(){var root=document.getElementById(${JSON.stringify(id)});if(!root)return;if(window.geppettoMoodleLoggedIn){root.classList.add('is-logged-in');var out=root.querySelector('[data-sm-auth="out"]');var href=out?out.getAttribute('href')||'':'';if(out&&window.geppettoMoodleLogoutUrl&&href.indexOf('/login/logout.php')!==-1){out.setAttribute('href',window.geppettoMoodleLogoutUrl);}}var row=root.closest('.madri-row')||root.closest('.builder-row');function lift(on){if(!row)return;if(on){if(row.getAttribute('data-sm-z')==null)row.setAttribute('data-sm-z',row.style.zIndex||'');row.style.zIndex='30';}else if(!root.classList.contains('is-open')&&!root.classList.contains('madri-site-menu--fixed')){row.style.zIndex=row.getAttribute('data-sm-z')||'';}}if(root.classList.contains('madri-site-menu--fixed'))lift(true);var btn=root.querySelector('.madri-site-menu__toggle');if(btn)btn.addEventListener('click',function(){var open=root.classList.toggle('is-open');btn.setAttribute('aria-expanded',open?'true':'false');var icons=btn.querySelectorAll('svg');if(icons[0])icons[0].style.display=open?'none':'block';if(icons[1])icons[1].style.display=open?'block':'none';lift(open||root.classList.contains('madri-site-menu--fixed'));});root.querySelectorAll('.madri-site-menu__caret').forEach(function(caret){caret.addEventListener('click',function(ev){ev.preventDefault();ev.stopPropagation();var item=caret.closest('.madri-site-menu__item');if(item)item.classList.toggle('is-open');});});root.addEventListener('mouseenter',function(){lift(true);});root.addEventListener('mouseleave',function(){lift(false);});})();</script>`;
  return `<div class="madri-site-menu-slot"><style>${SITE_MENU_CSS}</style><header id="${id}" class="${classes}" style="${vars}"><div class="madri-site-menu__bar">${logo}<nav class="madri-site-menu__nav" aria-label="Menu"><ul class="madri-site-menu__list">${renderItems(c.items)}</ul></nav>${login}${logout}<button type="button" class="madri-site-menu__toggle" aria-expanded="false" aria-label="Menu">${SVG_MENU}${SVG_CLOSE.replace('<svg ', '<svg style="display:none" ')}</button></div></header></div>${script}`;
}
